export enum EXTERNAL_ID {
  UP_FRANZI_1 = "UP_FRANZI_1",
  UP_FERRANTI_1 = "UP_FERRANTI_1",
  UP_SANBASILIO_1 = "UP_SANBASILIO_1",
  UP_BRTHNRGNMV_4 = "UP_BRTHNRGNMV_4",
}
